import { Injectable, EventEmitter } from '@angular/core';
@Injectable({
	providedIn: 'root'
})
export class ToolBarActionsService {
	setaTituloEmitter = new EventEmitter<string>();
	constructor() {}

	getToolBarActionsConfigs(isAdmin) {
		return {
			"/busca": {
				"busca": true,
				"placeholder": placeholder.completo,
				"filtro": false,
				"titulo": "Busca"
			},
			"/clientes": {
				"busca": true,
				"placeholder": placeholder.semPlaca,
				"filtro": true,
				"titulo": "Clientes"
			},
			"/cotacao/auto/formulario": {
				"titulo": "Formulário Auto"
			},
			"/cotacao/caminhao/formulario": {
				"titulo": "Formulário Caminhão"
			},
			"/cotacao/motocicleta/formulario": {
				"titulo": "Formulário Motocicleta"
			},
			"/cotacao/residencial/formulario": {
				"titulo": "Formulário Residencial"
			},
			"/cotacao/empresarial/formulario": {
				"titulo": "Formulário Empresarial"
			},
			"/cotacao/condominio/formulario": {
				"titulo": "Formulário Condomínio"
			},
			"/cotacao/auto/formulario/:idIntegracao": {
				"titulo": "Formulário Auto"
			},
			"/cotacao/caminhao/formulario/:idIntegracao": {
				"titulo": "Formulário Caminhão"
			},
			"/cotacao/motocicleta/formulario/:idIntegracao": {
				"titulo": "Formulário Motocicleta"
			},
			"/cotacao/residencial/formulario/:idIntegracao": {
				"titulo": "Formulário Residencial"
			},
			"/cotacao/empresarial/formulario/:idIntegracao": {
				"titulo": "Formulário Empresarial"
			},
			"/cotacao/condominio/formulario/:idIntegracao": {
				"titulo": "Formulário Condomínio"
			},
			"/cotacao/vida/formulario/:idIntegracao": {
				"titulo": "Formulário Vida"
			},
			"/cotacao/:ramo/coberturas/:idIntegracao": {
				"titulo": "Coberturas"
			},
			"/cotacao/:ramo/enviarCalculo/:idIntegracao": {
				"titulo": "Enviar Para Cálculo"
			},
			"/cotacao/:ramo/resultados/:idIntegracao": {
				"titulo": "Resultados"
			},
			"/cotacao/:ramo/simuladorComissoes/:idIntegracao": {
				"titulo": "Simulador De Comissões"
			},
			"/cotacoes": {
				"busca": true,
				"placeholder": placeholder.semFoneEmail,
				"filtro": true,
				"titulo": "Cotações",
			},
			"/configuracoes": {
				"titulo": "Configurações"
			},
			"/config-coberturas": {
				"titulo": "Coberturas"
			},
			"/config-corretora": {
				"titulo": "Corretora"
			},
			"/config-preferencias": {
				"titulo": "Preferências da Corretora"
			},
			"/config-ramos": {
				"busca": true,
				"placeholder": placeholder.ramo,
				"filtro": true,
				"titulo": "Ramos"
			},
			"/config-seguradoras": {
				"titulo": "Seguradoras"
			},
			"/config-usuarios": {
				"titulo": "Usuários"
			},
			"/contratar": {
				"titulo": "Contratação"
			},
			"/corretor-digital": {
				"busca": true,
				"placeholder": placeholder.completo,
				"filtro": false,
				"titulo": "Painel do Corretor Digital"
			},
			"/corretoras": {
				"busca": true,
				"placeholder": placeholder.corretora,
				"filtro": true,
				"titulo": "Corretoras"
			},
			"/dashboard": {
				"busca": true,
				"placeholder": placeholder.completo,
				"filtro": isAdmin,
				"titulo": "Dashboard"
			},
			"/documentos": {
				"busca": true,
				"placeholder": placeholder.apolice,
				"filtro": true,
				"titulo": "Documentos"
			},
			"/faturas-nfe": {
				"titulo": "Faturas e NF-e"
			},
			"/funil-de-vendas": {
				"busca": true,
				"placeholder": placeholder.semFoneEmail,
				"filtro": isAdmin,
				"titulo": "Funil de Vendas"
			},
			"/lista-negocios": {
				"busca": true,
				"placeholder": placeholder.completo,
				"filtro": isAdmin,
				"titulo": "Lista de Negócios"
			},
			"/lista-tarefas": {
				"busca": true,
				"placeholder": placeholder.completo,
				"filtro": isAdmin,
				"titulo": "Lista Tarefas"
			},
			"/orcamento?id=:id&ramo=:ramo": {
				"titulo": "Orçamento"
			},
			"/parcelas": {
				"busca": true,
				"placeholder": placeholder.completo,
				"filtro": false,
				"titulo": "Parcelas"
			},
			"/perfil-usuario": {
				"titulo": "Perfil Usuário"
			},
			"/preview-orcamento?id=:id": {
				"titulo": "Preview Orçamento"
			},
			"/suporte": {
				"titulo": "Suporte"
			}
		}
	}

	setaTituloPaginaAtual(novoTitulo) {
		this.setaTituloEmitter.emit(novoTitulo);
	}
}

const placeholder = {
	apolice: "Nome / CPF / CNPJ / Placa / Apolice",
	completo: "Nome / CPF / CNPJ / Fone / Email / Placa",
	corretora: "Buscar corretora",
	semFoneEmail: "Nome / CPF / CNPJ / Placa",
	semPlaca: "Nome / CPF / CNPJ / Fone / Email",
	ramo: "Buscar Ramo"
};
